export default __webpack_public_path__ + "static/media/cloud-1@3x.423f0a5d.png";